import { defineComponent, toRefs, computed, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, Fragment, createElementVNode, createBlock, withCtx, createVNode, createCommentVNode, renderSlot, createTextVNode, toDisplayString, renderList } from 'vue';
import { useToggle } from '@vueuse/core';
import { a as i, r as re } from '../OrAutocompleteV3-508d99c0.js';
import { OrIconV3 as script$1 } from '../or-icon-v3/index.js';
import { OrCheckboxV3 as script$2 } from '../or-checkbox-v3/index.js';
import { OrButtonV3 as script$3 } from '../or-button-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-tag-v3/index.js';

const CheckboxTreeRoot = [
// Layout
'flex', 'flex-col',
// Spacing
'gap-sm+ md:gap-sm'];
const CheckboxTreeRootParent = [
// Layout
'flex', 'flex-row', 'gap-xs'];

const getChildValues = children => {
  return children === null || children === void 0 ? void 0 : children.map(child => {
    if (child.disabled) {
      return undefined;
    }
    if (child.children) {
      return getChildValues(child.children);
    } else {
      return child.value;
    }
  });
};
function extractChildrenValues(children) {
  return i(getChildValues(children)).filter(Boolean);
}

var script = defineComponent({
  name: 'OrCheckboxTree',
  components: {
    OrIcon: script$1,
    OrCheckbox: script$2,
    OrButton: script$3
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      required: true
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    // State
    const {
      modelValue,
      item,
      expanded
    } = toRefs(props);
    const children = computed(() => item.value.children || []);
    const hasChildren = computed(() => children.value.length > 0);
    const childrenValues = computed(() => {
      return hasChildren.value ? extractChildrenValues(children.value) : [];
    });
    const proxyModelValue = re(modelValue, context.emit);
    const isAnyChildrenSelected = computed(() => {
      var _a;
      return (_a = proxyModelValue.value) === null || _a === void 0 ? void 0 : _a.some(value => {
        var _a;
        return (_a = childrenValues.value) === null || _a === void 0 ? void 0 : _a.includes(value);
      });
    });
    const isAllChildrenSelected = computed(() => {
      var _a;
      return childrenValues.value.length > 0 && ((_a = childrenValues.value) === null || _a === void 0 ? void 0 : _a.every(value => {
        var _a;
        return (_a = proxyModelValue.value) === null || _a === void 0 ? void 0 : _a.includes(value);
      }));
    });
    const isIntermediate = computed(() => {
      return isAnyChildrenSelected.value && !isAllChildrenSelected.value;
    });
    const [isOpen, setIsOpen] = useToggle(expanded.value);
    watch(expanded, value => {
      if (value !== undefined) {
        setIsOpen(value);
      }
    });
    // Styles
    const rootStyles = computed(() => ['or-checkbox-tree-v3', ...CheckboxTreeRoot]);
    // Styles
    const parentStyles = computed(() => [...CheckboxTreeRootParent]);
    // Methods
    const handleParentClick = () => {
      if (isAllChildrenSelected.value) {
        proxyModelValue.value = proxyModelValue.value.filter(value => !childrenValues.value.includes(value));
      } else {
        proxyModelValue.value = [...new Set([...proxyModelValue.value, ...childrenValues.value])];
      }
    };
    return {
      rootStyles,
      parentStyles,
      hasChildren,
      proxyModelValue,
      isOpen,
      setIsOpen,
      isIntermediate,
      isAllChildrenSelected,
      isAnyChildrenSelected,
      childrenValues,
      handleParentClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIcon = resolveComponent("OrIcon");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrCheckbox = resolveComponent("OrCheckbox");
  const _component_OrCheckboxTree = resolveComponent("OrCheckboxTree", true);
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.hasChildren ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.parentStyles)
  }, [_ctx.collapsible ? (openBlock(), createBlock(_component_OrButton, {
    key: 0,
    variant: 'link',
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.setIsOpen(!_ctx.isOpen))
  }, {
    default: withCtx(() => [createVNode(_component_OrIcon, {
      class: normalizeClass([_ctx.isOpen ? 'rotate-[180deg]' : 'rotate-0']),
      icon: 'arrow_drop_down',
      size: 'l'
    }, null, 8 /* PROPS */, ["class"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])) : createCommentVNode("v-if", true), createVNode(_component_OrCheckbox, {
    "model-value": _ctx.isAllChildrenSelected,
    value: true,
    indeterminate: _ctx.isIntermediate,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    onClick: _ctx.handleParentClick
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "checkboxLabel", {
      item: _ctx.item
    }, () => [createTextVNode(toDisplayString(_ctx.item.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["model-value", "indeterminate", "disabled", "readonly", "onClick"])], 2 /* CLASS */), _ctx.hasChildren && _ctx.isOpen ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass([_ctx.collapsible ? 'ml-2xl' : 'ml-lg'])
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.item.children, child => {
    return openBlock(), createBlock(_component_OrCheckboxTree, {
      key: child.value || child.label,
      modelValue: _ctx.proxyModelValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.proxyModelValue = $event),
      class: normalizeClass(['mt-xs']),
      item: child,
      collapsible: child.collapsible,
      expanded: child.expanded,
      disabled: _ctx.disabled || child.disabled,
      readonly: _ctx.readonly || child.readonly
    }, {
      checkboxLabel: withCtx(({
        item
      }) => [renderSlot(_ctx.$slots, "checkboxLabel", {
        item: item
      }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "item", "collapsible", "expanded", "disabled", "readonly"]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 64 /* STABLE_FRAGMENT */)) : (openBlock(), createBlock(_component_OrCheckbox, {
    key: 1,
    modelValue: _ctx.proxyModelValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.proxyModelValue = $event),
    value: _ctx.item.value,
    disabled: _ctx.disabled || _ctx.item.disabled,
    readonly: _ctx.readonly || _ctx.item.readonly
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "checkboxLabel", {
      item: _ctx.item
    }, () => [createTextVNode(toDisplayString(_ctx.item.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue", "value", "disabled", "readonly"]))], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-checkbox-tree-v3/OrCheckboxTree.vue";

export { script as OrCheckboxTreeV3 };
